import { useContext, useState, useEffect } from 'react'
import { Grid, Button, Box, Typography } from '@mui/material'
import { LocalPoliceRounded } from "@mui/icons-material"
import { WebSocketContext } from "../../Providers/WebSocket/WebSocketContext"
import { ChangeComponentContext } from '../../Providers/ChangeComponentContext/ChangeComponentContext'
import { EventosContext } from "../../Providers/EventosContext/EventosContext"
import { showNotify } from "../../Utils/Utils"
import { RondaContext } from '../../Providers/RondaContext/RondaContext'
import OneTextArea from "../OneTextArea/OneTextArea"
import { UserContext } from '../../Providers/UserContext/UserContex'
import { useAppTheme } from '../../Providers/ThemeContext/ThemeContext'

function Ronda({ idCentral }) {
    const { theme } = useAppTheme()
    const { sendWs, addRoute } = useContext(WebSocketContext)
    const { changeShowComponent } = useContext(ChangeComponentContext)
    const { eventoSelecionado, updateEventoSelecionado, finalizarEvento } = useContext(EventosContext)
    const { setRespostaLog } = useContext(RondaContext)
    const { user, check } = useContext(UserContext)

    const [perguntas, setPerguntas] = useState([])
    const [pergResp, setPergResp] = useState([])
    const [idEevento, setIdEvento] = useState([])
    const [listaEntrada, setListaEntrada] = useState([])

    useEffect(() => {
        addRoute("pegaRondaSelecionada", pegaRonda)
        addRoute("listaPortaEquip", getListaEntrada)

        let resps = localStorage.getItem('o_ronda_resp')
        if (resps) { resps = JSON.parse(resps) }

        if (resps && resps[eventoSelecionado.id]) {
            const resp = resps[eventoSelecionado.id]
            for (let i = 0; i < resp.length; i++) {
                resposta({ value: resp[i], id: i })
            }
        }
    }, [])

    useEffect(() => {
        if (idEevento != eventoSelecionado.id && eventoSelecionado.evento == "ONRV") {
            setRespostaLog('')
            setPergResp(getEventLocalStorage(eventoSelecionado.id))
            setIdEvento(eventoSelecionado.id)

            sendWs("pegaRondaSelecionada", eventoSelecionado.auxiliar) // auxiliar nesse evento guarda o id da one_ronda
        }
    }, [eventoSelecionado.id])

    useEffect(() => {
        setRespostaLog()
        sendWs("pegaRondaSelecionada", eventoSelecionado.auxiliar)
    }, [eventoSelecionado.auxiliar, eventoSelecionado.id])

    // useEffect(() => {
    //     let resps = localStorage.getItem('o_ronda_resp')
    //     if (resps) { resps = JSON.parse(resps) } else { resps = {} }

    //     resps[eventoSelecionado.id] = pergResp
    //     localStorage.setItem('o_ronda_resp', JSON.stringify(resps))
    // }, [pergResp])

    const trataEventosDisabled = () => {
        if (check && (check.estado_jornada == 4 || check.estado_jornada == 2 || check.estado_jornada == false)) {
            return true
        }
        return (eventoSelecionado.id == 0 || (!eventoSelecionado.usuario_tratando || eventoSelecionado.usuario_tratando.id != user.id) || eventoSelecionado.status != 2)
    }

    const pegaRonda = (msg) => {
        const ronda = msg.data.rondaSelecionada
        const rondaPerguntas = ronda.perguntas_ronda
        const array = rondaPerguntas.split('-|-')
        const entradas = ronda.entrada_monitorada

        setPerguntas(array)
        buscaEntradasCondominio(entradas)
    }

    const LogEntradas = () => {
        if (listaEntrada.length > 0) {
            let result = '\n\nEntrada(s):\n'

            listaEntrada.forEach((entrada, index) => {
                let statusSensor = entrada.status_sensor == 0 ? 'aberto' : 'fechado'
                let equipamentoString = ''

                if (entrada.equipamentos && entrada.equipamentos.length > 0) {
                    entrada.equipamentos.forEach((eq) => {
                        let statusEquipamento = eq.online == 1 ? 'online' : 'offline'
                        equipamentoString += ` | ${eq.nome}: ${statusEquipamento}`
                    })
                }

                let entradaString = `${entrada.descricao} - Sensor: ${statusSensor}${equipamentoString}`

                result += entradaString

                if (index < listaEntrada.length - 1) {
                    result += '\n'
                }
            })

            return result
        }
    }

    const handleClickFinalizar = () => {
        if (!PerguntasRespondidas()) {
            showNotify("warning", `Responda todoas as perguntas para continuar!`)
        }

        let paraLog = Object.keys(pergResp).map((index) => {
            const pergunta = perguntas[index]
            const resposta = pergResp[index]
            return `${parseInt(index) + 1}) ${pergunta} R: ${resposta}`
        }).join('\n\n')

        let entradas = LogEntradas()
        paraLog += entradas

        updateEventoSelecionado({ obs_fechamento: paraLog })
        setTimeout(() => {
            finalizarEvento({ id: eventoSelecionado.id, observacao: paraLog })
        }, 500)
    }

    const handleClickFinalizarOS = () => {
        let paraLog = Object.keys(pergResp).map((index) => {
            const pergunta = perguntas[index]
            const resposta = pergResp[index]
            return `${parseInt(index) + 1}) ${pergunta} R: ${resposta}`
        }).join('\n\n')

        let entradas = LogEntradas()
        paraLog += entradas

        setRespostaLog(paraLog)
        changeShowComponent('ordemServico')
    }

    const resposta = (target) => {
        const resp = target.value
        const index = parseInt(target.id, 10)

        setPergResp((prevState) => {
            let updatedState = [...prevState]
            updatedState[index] = resp
            return updatedState
        })

        let resps = localStorage.getItem('o_ronda_resp')
        if (resps) { resps = JSON.parse(resps) } else { resps = {} }

        if (!resps[eventoSelecionado.id]) {
            resps[eventoSelecionado.id] = []
        }
        resps[eventoSelecionado.id][index] = resp
        localStorage.setItem('o_ronda_resp', JSON.stringify(resps))
    }

    const getEventLocalStorage = (id) => {
        let resps = localStorage.getItem('o_ronda_resp')
        if (resps) { resps = JSON.parse(resps) } else { resps = {} }

        let ret = []
        if (resps[id]) {
            ret = resps[id]
        }

        return ret
    }

    const getListaEntrada = (msg) => {
        const arrayListaEntradas = msg.data.listaPortaEntrada
        setListaEntrada(arrayListaEntradas)
    }

    const buscaEntradasCondominio = (entradas) => {
        sendWs("listaPortaEquip", { id_central: idCentral, ids: entradas })
    }

    const PerguntasRespondidas = () => {
        if (!pergResp || pergResp.length == 0) {
            return false
        }

        if (perguntas.length > 0 && pergResp.length < perguntas.length) {
            return false
        }

        let flag = true
        pergResp.forEach(p => {
            if (p.length == 0) {
                flag = false
            }
        })

        return flag
    }

    return (
        <Grid sx={{ gap: '5px', display: 'flex', flexDirection: 'column', height: '100%', backgroundColor: '#D9D9D9', padding: '10px', overflowY: 'scroll', flexGrow: 1, width: '100%' }}>
            <Box sx={{ minHeight: '35%' }}>
                <Box sx={{ display: 'flex', width: '100%', justifyContent: 'flex-start', gap: '5px', alignItems: 'center' }}>
                    <LocalPoliceRounded sx={{ color: 'blue', fontSize: '34px' }}/>
                    <Typography sx={{ fontWeight: 'bold' }}>Ronda Automática</Typography>
                </Box>

                {/* ENTRADAS */}
                <Grid xs={12} >
                    <Typography sx={{ paddingTop: '10px' }}>Entrada(s):</Typography>
                    {
                        listaEntrada.length > 0 && listaEntrada.map((entrada, i) => {
                            return (
                                <Box key={'etr_' + i} style={{ color: 'black', display: 'flex', gap: '6px' }}>
                                    <strong>{entrada.descricao}</strong> <span>- Sensor:</span> <strong style={{ color: (entrada.status_sensor == 0 ? theme.palette.off : '#00b100') }}>{(entrada.status_sensor == 0 ? 'aberto' : 'fechado')}</strong> |

                                    {entrada.equipamentos && entrada.equipamentos.length > 0 && entrada.equipamentos.map((eq, x) => {
                                        return (
                                            <Box key={'eq_' + x} sx={{ display: 'flex', gap: '6px' }}>
                                                {eq.nome}: <Box sx={{ fontWeight: '600', color: (eq.online ? '#00b100' : theme.palette.off), display: 'flex' }}>{(eq.online ? 'online' : 'offline')}</Box>
                                            </Box>
                                        )
                                    })

                                    }
                                </Box>
                            )
                        })}
                </Grid>

                {/* PERGUNTAS */}
                <Typography sx={{ fontWeight: 'bold', paddingTop: '20px' }}>Responda as perguntas para finalizar a ronda:</Typography>
                <span style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    {perguntas.map((pergunta, index) => {
                        const value = pergResp[index] || ''
                        return (
                            <Box key={index} >
                                <Typography>{`${index + 1} - ${pergunta}`}</Typography>
                                <OneTextArea id={index} type="text" value={value} onChange={(event) => resposta(event.target)} disabled={trataEventosDisabled()} newSx={{ fontSize: '27px', marginBottom: '5px' }} />
                            </Box>
                        )
                    })}
                    <span style={{ display: 'flex', justifyContent: 'center', width: '100%', paddingTop: '30px', gap: '20px', marginBottom: '20px' }}>

                        <Button
                            variant="contained"
                            color="one_primary"
                            onClick={() => handleClickFinalizarOS()}
                            disabled={trataEventosDisabled() || !PerguntasRespondidas()}
                        >
                                Abrir O.S. e Finalizar
                        </Button>

                        <Button
                            variant="contained"
                            color="one_primary"
                            onClick={() => handleClickFinalizar()}
                            disabled={trataEventosDisabled() || !PerguntasRespondidas()}
                        >
                                Finalizar
                        </Button>

                    </span>
                </span>
            </Box>
        </Grid>
    )
}

export default Ronda
